import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux'
import blank_profile from '../../assets/img/blank_profile.png'

export default function Pen(props) {



    const [is_loved, setLoved] = useState(false)
    const [is_forked] = useState(true)

        let { 
            pen_id : id, pen_user_id, pen_title, pen_description, 
            pen_html, pen_css, pen_js, cssSettings, htmlSettings, 
            jsSettings, views, loves, user_photo_url, pen_user_name, love_count, fork_count } = props.penData;
            const { user_data, is_logged_in } = useSelector(state => state.authReducer)
useEffect(() => {
    if(!is_logged_in) return
    if(loves.find(love => love === user_data.uid))
        setLoved(true)
},[])


const lovePost = () => {
    if(!is_logged_in) return
    if(is_loved) {
        // unlike pen
    } else {
        // like pen
    }
}

const forkPost = () => {
    if(!is_logged_in) return
    if(is_loved) {
        // unlike pen
    } else {
        // like pen
    }
}
        // let {htmlSettings,cssSettings,jsSettings} = scripts
        let { htmlClassTag, head } = htmlSettings 
        let { cssCdnList } = cssSettings
        let { jsCdnList } = jsSettings

        let repeatFilter = {
            css: {},
            js: {}
        }

        let cssList=cssCdnList.filter(val => val).filter( val => {
            if(!repeatFilter.css[val]) {
                repeatFilter.css[val] = 1
                return true
            } else {
                return false
            }
        })
        let jsList = jsCdnList.filter(val => val).filter( val => {
            if(!repeatFilter.js[val]) {
                repeatFilter.js[val] = 1
                return true
            } else {
                return false
            }
        })

        
        let stylesheetString = cssList.reduce((string, element) => {
            return string + `<link rel='stylesheet' href='${element}'>`
        }, '')

        let jsLibraryString = jsList.reduce((string, element) => {
            return string + `<script type='text/javascript' src='${element}'></script>`
        }, '')

        
        let srcDoc = `
        <html class='${htmlClassTag || ''}'>
            <head>
                ${stylesheetString}
                ${head || ''}            
            </head>
            <body>${pen_html}</body>
            <style>${pen_css}</style>
            ${jsLibraryString}
            
            <script>${pen_js}</script>
        </html>`;
return (
    <div className="showPen">
        <div onClick={() => window.location.href = `#/editor/${id}`}>
            <div className="overlayContainer">
                <div className="overlayContainer">
                    <div className="pen-iframe-container">
                        <iframe style={{ backgroundColor: 'white' }} scrolling="no" className="pen-iframe" title={props.id} srcDoc={srcDoc}></iframe>
                    </div>
                    <div className="overlay">
                        <div className="text">{pen_description}</div>
                    </div>
                </div>
            </div>
        </div>
        <div className="penInfoContainer">
            <div className="penInfo">
                <img className="profilePicture" src={user_photo_url ? user_photo_url : blank_profile } alt="" />
                <div>
                    <Link className="penLink" to={`/editor/${id}`}><h3 id="displayUserName">{pen_title}</h3></Link>
                    <Link className="userLink" to={`/profile/${pen_user_id}`}><h5>{pen_user_name}</h5></Link>
                </div>
            </div>
            <div className="penPopularity">
                <i className="fa fa-eye"></i>
                <h3>{views == 0 ? "" : views}</h3>
                <i style={{ color: is_forked ? "#d6ba06" : "lightgray" }} onClick={() => forkPost()} className="fa fa-code-fork"></i>
                <h3>{fork_count > 0 && fork_count}</h3>
                <i style={{ color: is_loved ? "#e6473c" : "lightgray" }} onClick={() => lovePost()} className="fa fa-heart"></i>
                <h3>{love_count > 0 && love_count}</h3>
            </div>
        </div>
    </div>
)
}



// WEBPACK FOOTER //
// ./src/components/Pen/Pen.js